import { Component, OnInit, ViewChild } from '@angular/core';
import { AppService } from '../app.service';
import { Configs } from '../app.config';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { DialogDataExampleDialog } from '../popup.component';
import { MzModalComponent } from 'ngx-materialize';
@Component({
  selector: 'app-my-specialincentives',
  templateUrl: './my-specialincentives.component.html',
  styleUrls: ['./my-specialincentives.component.less']
})
export class MySpecialincentivesComponent implements OnInit {
  @ViewChild('ViewSpecialIncentive') ViewSpecialIncentive: MzModalComponent
  displayedColumns: string[] = ['Parameter', 'Measurement', 'Weightage', 'Period', 'Target', 'Threshold'];
  userInfo: any;
  masterData: any;
  selectedPeriod: any;
  PSNO: string;
  periodValues: any;
  UserData: any;
  loadUser: boolean = false;
  errorMessage: string;
  SpecialIncentiveURLByCountry: string = '';
  tblMetrics: any;
  mydata: any;
  FYPeriodid: any;
  StatusId: any;
  ManagerName: string;
  IsManager: boolean = false;
  SpecialIncentiveText: string = '';
  SpecialIncentiveURL: string = '';
  SpecialIncentiveTextByCountry: string = '';
  AccountList: any;
  showMetricsTable: boolean = false;
  plandata; any;
  planid: any;
  id: any;

  SearchPsnoModal: any;
  ChipPSNos:any = [];
  ModalDate: any;
  currency_typeOptionSelected: any;
  Amount: any;
  SpecialIncentiveName: any;
  accountName: any;
  dealValue: any;
  netNew: any;
  soldEbit: any;
  newServiceLine: any;
  revenueContribution: any;
  revenue: any;
  ebitPercentage: any;
  first12MonthRevenue: any;
  rateChangePercentage: any;
  revenueImpact: any;
  L_SpecialIncentiveStatus: any;
  L_SpecialIncentivePendingWith: any;
  L_AppType: any;
  L_PeriodId: any;
  SpecialIncentiveApprovalID: any;
  SpecialIncentiveDataForUser: any = [];
  si_typeOptionSelected: any;
  


  constructor(private appService: AppService, private configs: Configs, private _router: Router, private route: ActivatedRoute, public dialog: MatDialog) {
    this.selectedPeriod = '0';
    this.PSNO = '';
    this.periodValues = [];
    this.UserData = {};
    this.loadUser = false;
    this.tblMetrics = [];
    this.mydata = {};
    this.AccountList = '';
    this.plandata = [];

    this.SearchPsnoModal = '';
    this.ChipPSNos = [];
    this.ModalDate = '';
    this.currency_typeOptionSelected = '';
    this.Amount = 0;
    this.SpecialIncentiveName = '';
    this.accountName = '';
    this.dealValue = 0;
    this.netNew = 0;
    this.soldEbit = 0;
    this.newServiceLine = '';
    this.revenueContribution = 0;
    this.revenue = 0;
    this.ebitPercentage = 0;
    this.first12MonthRevenue = 0;
    this.rateChangePercentage = 0;
    this.revenueImpact = 0;
    this.L_SpecialIncentiveStatus = '';
    this.L_SpecialIncentivePendingWith = '';
    this.L_AppType = 1;
    this.L_PeriodId = 1;
    this.SpecialIncentiveApprovalID = 0;
    this.si_typeOptionSelected = 0;
   }

  ngOnInit() {
    this.userInfo = this.appService.GetLoginUserInfo();
    this.masterData = this.appService.GetMasterDetails();
    this.selectedPeriod = '3';
    this.PSNO = this.userInfo.PS_No;

    if (this.userInfo != null) {

      var checkAccess = this.appService.CheckAccessForRoute(this._router.url, this.userInfo.UserAccessOptions);
      if (checkAccess) {
        var UserData = {
          "PS_No": this.PSNO,
          "AppType": this.userInfo.AppType
        }
        this.appService.GetDataFromAPI(this.configs.GetYearsForTargetUpload(), UserData)
          .then(response => {
            this.appService.SetLoadingShow(false);
            if (response.ResponseCode == this.configs.RetCodeFailure()) {
              this.dialog.open(DialogDataExampleDialog, {
                data: response.ResponseData
              });
            }
            else {
              this.periodValues = response.ResponseData.dtYearsForTrgts;
              this.selectedPeriod = this.masterData.dtPeriodDet[0].TargetUploadYearText;
              this.GetEmployeeData();
            }
          });
      }
      else {
        this._router.navigate(['no-access']);
      }
    }
    else {
      window.location.href = "../Index.html";
    }
  }

  GetEmployeeData() {
    var data = {
      "psNo": this.PSNO,
      "PeriodId": this.selectedPeriod,
      "AppType": this.userInfo.AppType
    };
    this.appService.SetLoadingShow(true);
    var url = this.configs.GetEmployeeDetailsForDashBoardURL();
    this.appService.GetDataFromAPI(url, data)
      .then(response => {
        this.appService.SetLoadingShow(false);
        if (response.ResponseCode == this.configs.RetCodeFailure()) {
          this.dialog.open(DialogDataExampleDialog, {
            data: response.ResponseData
          });
        }
        else {
          this.UserData = response.ResponseData;
          this.loadUser = true;
          this.onPeriodChange(this.selectedPeriod);
        }
      }
        ,
        error => {
          this.errorMessage = <string>error;
        });
  }

  onPeriodChange(id: any): void {
    this.SpecialIncentiveURLByCountry = '';
    if (id.toString() != '') {
      var UserData = {
        "PSNo": this.PSNO,
        "PeriodId": id.toString(),
        "AppType": this.userInfo.AppType
      }
      this.appService.SetLoadingShow(true);
      var url = this.configs.GetMySpecialIncentivesForYearURL();
      this.appService.GetDataFromAPI(url, UserData)
        .then(response => {
          this.appService.SetLoadingShow(false);
          if (response.ResponseCode == this.configs.RetCodeFailure()) {
            this.dialog.open(DialogDataExampleDialog, {
              data: response.ResponseData
            });
          }
          else {
            this.loadUser = true;
            this.tblMetrics = response.ResponseData.SpecialIncentivesList;
            this.mydata = response.ResponseData.UserDetails;
            this.FYPeriodid = this.mydata.FYPeriodId;
            this.StatusId = this.mydata.StatusId;
            this.ManagerName = this.mydata.ManagerName;
            if (this.ManagerName == this.userInfo.Name) {
              this.IsManager = true;
            }
            if (this.mydata.IncentivePlanURL != null) {
              this.SpecialIncentiveText = this.mydata.IncentivePlanText + id.toString();
              this.SpecialIncentiveURL = this.mydata.IncentivePlanURL + id.toString() + '.pdf';
            }
            if (this.mydata.IncentivePlanTextByCountry != '' && (this.mydata.IncentivePlanURLByCountry != '' && this.mydata.IncentivePlanURLByCountry != null)) {
              this.SpecialIncentiveTextByCountry = this.mydata.IncentivePlanTextByCountry + id.toString();
              this.SpecialIncentiveURLByCountry = this.mydata.IncentivePlanURLByCountry + id.toString() + '.pdf';
            }
            this.GetPlanData(id);

            this.AccountList = response.ResponseData.UserDetails.Accounts;
            if (this.tblMetrics.length > 0) {
              this.showMetricsTable = true;
              // this.displayedColumns = ['Parameter', 'Measurement', 'Weightage', 'Period', 'Target', 'Threshold'];
            }
            else {
              this.showMetricsTable = false;
              this.dialog.open(DialogDataExampleDialog, {
                data: "No record found."
              });
              return;
            }
          }
        }
          ,
          error => {
            this.errorMessage = <string>error; //this.appService.SetLoadingShow(false);
          });
    }
  }

  GetPlanData(id: any) {
    var data = {
      "PSNo": this.PSNO,
      "PeriodId": id.toString(),
      "AppType": this.userInfo.AppType
    }
    this.appService.SetLoadingShow(true);
    var url = this.configs.GetPlanDataURL();
    this.appService.GetDataFromAPI(url, data)
      .then(response => {
        this.appService.SetLoadingShow(false);
        if (response.ResponseCode == this.configs.RetCodeFailure()) {
          this.dialog.open(DialogDataExampleDialog, {
            data: response.ResponseData
          });
        }
        else {
          this.plandata = response.ResponseData;
          // this.planid = this.plandata[0].PlanId;
          this.planid = '750';
          this.id = id;
        }
      }
        ,
        error => {
          this.errorMessage = <string>error;
        });
  }

  DownLoadSpecialIncentives(Psno,PeriodId,AppType,SpecialIncentiveApprovalId): void {
    // FYPeriodId = 16;
    // Status = 'Special Incentive Letter Released';
    // PendingWith = 'CBO';
    // AppType = 'SPM';

    var IsReleased = '';
    var SpecialIncentiveLetterType = '';
    SpecialIncentiveLetterType = 'Final'; IsReleased = 'Released';

    this.DownLoadSpecialIncentivesApi(Psno, PeriodId, 'employee', IsReleased, SpecialIncentiveLetterType, AppType, SpecialIncentiveApprovalId);
 
  }
  DownLoadSpecialIncentivesApi(Psno, FYPeriodId, Role, SpecialIncentiveStatus, SpecialIncentiveLetterType, AppType, SpecialIncentiveApprovalId): void {
    var apptypetext = 'SPM';
    console.log("ds" + Psno)
    if(AppType == 1) {apptypetext = 'SPM';}
    if(AppType == 1) {apptypetext = 'DIS';}

    console.log(SpecialIncentiveApprovalId);


    var data = {
      "PSNO": Psno,
      "PeriodId": FYPeriodId,
      "Role": Role,
      "SpecialIncentiveStatus": SpecialIncentiveStatus,
      "SpecialIncentiveLetterType": SpecialIncentiveLetterType,
      "AppType": 'SPM',
      "SpecialIncentiveApprovalId" : SpecialIncentiveApprovalId
    };
    this.appService.SetLoadingShow(true);
    var url = this.configs.GetSpecialIncentiveLetterURL();
    this.appService.GetDataFromAPI(url, data)
      .then(response => {
        this.appService.SetLoadingShow(false);
        if (response.ResponseCode == this.configs.RetCodeFailure()) {
          this.dialog.open(DialogDataExampleDialog, {
            data: response.ResponseData
          });
        }
        else {
          this.appService.DownloadSpecialIncentiveletter(response.ResponseData);
        }
      });


  }

  ViewSpecialIncentiveModal(SpecialIncentiveApprovalId: string, periodid: string) {
  this.SpecialIncentiveApprovalID = SpecialIncentiveApprovalId;
  var data = {
  'SpecialIncentiveApprovalId': SpecialIncentiveApprovalId,
  'PeriodId': periodid,
  'AppType': this.userInfo.AppType
}

this.appService.SetLoadingShow(true);
var url = this.configs.GetSpecialIncentiveForUserURL();

this.appService.GetDataFromAPI(url, data)
  .then(response => {
    this.appService.SetLoadingShow(false);
    if (response.ResponseCode == this.configs.RetCodeFailure()) {
      this.dialog.open(DialogDataExampleDialog, {
        data: response.ResponseData
      });
    }
    else {
      this.SpecialIncentiveDataForUser = [];
      this.SpecialIncentiveDataForUser = response.ResponseData.SpecialIncentivesList;

      console.log(this.SpecialIncentiveDataForUser);


      if (this.SpecialIncentiveDataForUser.length > 0) {
          this.SearchPsnoModal = this.SpecialIncentiveDataForUser[0].CBOPSNo + " " + this.SpecialIncentiveDataForUser[0].CBOName;
          // this.ChipPSNos = this.SpecialIncentiveDataForUser[0].PSNOs;
          this.ChipPSNos = [];
          for (let i = 0; i < this.SpecialIncentiveDataForUser[0].PSNo.length; i++) {
            this.ChipPSNos.push(this.SpecialIncentiveDataForUser[0].PSNo[i].PSNO);
        }
          this.ModalDate = this.SpecialIncentiveDataForUser[0].Date;

          this.currency_typeOptionSelected = this.SpecialIncentiveDataForUser[0].Currency;
          this.si_typeOptionSelected = this.SpecialIncentiveDataForUser[0].SpecialIncentiveType;
          this.si_typeOptionSelected = parseInt(this.si_typeOptionSelected, 10);

          this.Amount = this.SpecialIncentiveDataForUser[0].TotalValue;
          this.SpecialIncentiveName = this.SpecialIncentiveDataForUser[0].SpecialIncentiveName;

          this.accountName = this.SpecialIncentiveDataForUser[0].AccountName;
          this.dealValue = this.SpecialIncentiveDataForUser[0].DealValue;
          this.netNew = this.SpecialIncentiveDataForUser[0].NetNew;
          this.soldEbit = this.SpecialIncentiveDataForUser[0].SoldEBIT;
          this.newServiceLine = this.SpecialIncentiveDataForUser[0].NewServiceLine;
          this.revenueContribution = this.SpecialIncentiveDataForUser[0].RevenueContribution;
          this.revenue = this.SpecialIncentiveDataForUser[0].Revenue;
          this.ebitPercentage = this.SpecialIncentiveDataForUser[0].EBITPercentage;
          this.first12MonthRevenue = this.SpecialIncentiveDataForUser[0].First12MonthRevenue;
          this.rateChangePercentage = this.SpecialIncentiveDataForUser[0].RateChangePercentage;
          this.revenueImpact = this.SpecialIncentiveDataForUser[0].RevenueImpact;
          this.L_SpecialIncentiveStatus = this.SpecialIncentiveDataForUser[0].StatusDesc;
          this.L_SpecialIncentivePendingWith = this.SpecialIncentiveDataForUser[0].PendingWith;
          this.L_AppType = this.SpecialIncentiveDataForUser[0].Apptype;
          this.L_PeriodId = this.SpecialIncentiveDataForUser[0].PeriodId;



          console.log(this.SearchPsnoModal);
          console.log("data init");
          console.log(this.SearchPsnoModal);
          console.log(this.si_typeOptionSelected);
          console.log(this.SpecialIncentiveApprovalID);
          console.log(this.ChipPSNos);
          console.log(this.currency_typeOptionSelected);
          console.log(this.Amount);
          console.log(this.ModalDate);
          console.log(this.accountName);
          console.log(this.dealValue);
          console.log(this.netNew);
          console.log(this.soldEbit);
          console.log(this.newServiceLine);
          console.log(this.revenueContribution);
          console.log(this.revenue);
          console.log(this.ebitPercentage);
          console.log(this.first12MonthRevenue);
          console.log(this.rateChangePercentage);
          console.log(this.revenueImpact);
          this.ViewSpecialIncentive.openModal();
        }
        else {
          this.dialog.open(DialogDataExampleDialog, {
            data: "No data available"
          });
      }
    }
    


    }
    ,
    error => {

    });
}


}
